module.exports = __webpack_public_path__ + "static/media/batteries-favicon.c699c80e.png";